import { BasisCell, BasisLegend } from '@/features/cost-basis/components';
import { useBasisEnabled } from '@/features/cost-basis/context';
import React, { memo } from 'react';
import { AllHoldingsTab as SharedAllHoldingsTab } from '@wavvest/wealth-ui';
import { selectApexLoading } from '@/store/features/apex/apex-selectors';
import { useAppSelector } from '@/store/hooks';
import {
  selectPlaidAccounts,
  selectPlaidHoldings,
  selectPlaidLoading,
} from '@/store/features/plaid/plaid-selectors';
import { useApexHoldingsAccounts } from '@/hooks/useApexHoldingsAccounts';

const AllHoldingsTab: React.FC = () => {
  const basisEnabled = useBasisEnabled();
  const apexLoading = useAppSelector(selectApexLoading);
  const plaidLoading = useAppSelector(selectPlaidLoading);
  // Legacy per-account Apex accounts for a legacy Apex firm, or lightweight
  // {id, holdings} shims built from firm-data's blended custodian accounts
  // for a firm-data + Apex firm — see useApexHoldingsAccounts.
  const apexAccounts = useApexHoldingsAccounts();
  const plaidAccounts = useAppSelector(selectPlaidAccounts);
  const plaidHoldingsData = useAppSelector(selectPlaidHoldings);

  return (
    <>
      <BasisLegend />
      <SharedAllHoldingsTab
        renderCostBasis={
          basisEnabled
            ? (accountId, holding, gain, external) => (
                <BasisCell
                  accountId={accountId}
                  holding={holding}
                  gain={gain}
                  external={external}
                />
              )
            : undefined
        }
        apexAccounts={apexAccounts}
        plaidAccounts={plaidAccounts}
        plaidHoldings={plaidHoldingsData}
        isLoading={apexLoading.holdings || plaidLoading.holdings}
        recalculateWeightsOnFilter
      />
    </>
  );
};

export default memo(AllHoldingsTab);
